export type ColorKeys = 'primary' | 'warning' | 'success' | 'gray' | 'accessory-sky' | 'accessory-purple';

export const cardColorClass = (color?: ColorKeys) => {
  if (!color) return 'bg-gray-2 border-gray-3 hover:border-gray-4';
  const variants: Record<ColorKeys, string> = {
    primary: 'bg-primary-2 border-primary-3 hover:border-primary-4',
    warning: 'bg-warning-2 border-warning-3 hover:border-warning-4',
    success: 'bg-success-2 border-success-3 hover:border-success-4',
    gray: 'bg-gray-2 border-gray-3 hover:border-gray-4',
    'accessory-sky': 'bg-accessory-sky-2 border-accessory-sky-3 hover:border-accessory-sky-4',
    'accessory-purple': 'bg-accessory-purple-2 border-accessory-purple-3 hover:border-accessory-purple-4',
  };
  return variants[color] || 'bg-gray-2 border-gray-3 hover:border-gray-4';
};

export const cardIconColorClass = (color?: ColorKeys) => {
  if (!color) return 'border-gray-6';
  const variants: Record<ColorKeys, string> = {
    primary: 'border-primary-6',
    warning: 'border-warning-4',
    success: 'border-success-6',
    gray: 'border-gray-6',
    'accessory-sky': 'border-accessory-sky-6',
    'accessory-purple': 'border-accessory-purple-6',
  };
  return variants[color] || 'border-gray-6';
};

export const iconColorClass = (color?: ColorKeys) => {
  if (!color) return '!text-gray';
  const variants: Record<ColorKeys, string> = {
    primary: '!text-primary',
    warning: '!text-warning',
    success: '!text-success',
    gray: '!text-gray',
    'accessory-sky': '!text-accessory-sky-11',
    'accessory-purple': '!text-accessory-purple-11',
  };
  return variants[color] || '!text-gray';
};

export const buttonColorLink = (color?: ColorKeys) => {
  if (!color) return 'primary';
  const variants: Record<ColorKeys, string> = {
    primary: 'primary',
    warning: 'warning',
    success: 'success',
    gray: 'gray',
    'accessory-sky': 'success',
    'accessory-purple': 'accessory-purple',
  };
  return variants[color] || 'primary';
};
